import { useCallback, useRef } from "react";
import { ActiveSheet } from "./ActiveSheet";
import { DesktopState } from "./desktopState";

function getIdealPos(activeSheetRef: HTMLDivElement | null): [number, number] {
  if (!activeSheetRef) return [200, 200];
  let rect = activeSheetRef.getBoundingClientRect();
  let x = rect.left;
  let y = rect.top - 16 * 4 + 17;
  return [x, y];
}


export function Teletype({ desktopState, setDesktopState }: { desktopState: DesktopState; setDesktopState: (value: React.SetStateAction<DesktopState>) => void; }) {
  const activeSheetRef = useRef<HTMLDivElement>(null);
  const handleCut = useCallback((lineIdx: number) => {
    if (desktopState.tool !== "SCISSORS") return;
    let pos = getIdealPos(activeSheetRef.current);
    let preCut = desktopState.teletype.activePaper.slice(0, lineIdx + 1);
    let postCut = desktopState.teletype.activePaper.slice(lineIdx + 1);
    setDesktopState(desktopState => ({
      ...desktopState,
      pinboard: {
        ...desktopState.pinboard,
        papers: [...desktopState.pinboard.papers, { id: Math.random().toString(), type: "text", pos, lines: preCut }]
      },
      teletype: {
        ...desktopState.teletype,
        activePaper: postCut
      }
    }));
  }, [desktopState, setDesktopState]);

  return (
    <section className="flex flex-col justify-end absolute left-0 bottom-0 m-8">
      <ActiveSheet desktopState={desktopState} onCut={handleCut} activeSheetRef={activeSheetRef} />
    </section>
  );
}
